export const seriesTickerFromMarketTicker = (marketTicker: string): string => marketTicker.split('-')[0];

// TODO: Remove this hardcoded map. We should have a field on the backend that explicitly
// assigns props to the component event that they should link to in the web/app.
export const sportSeriesRedirects: Record<string, string> = {
    KXNFLSPREAD: 'KXSB',
    KXNFLTOTAL: 'KXSB',
    KXNFLANYTD: 'KXSB',
    KXNFLFIRSTTD: 'KXSB',
    KXNFL2TD: 'KXSB',
};

// For SEO purposes, we want to remove all non-alphanumeric characters from the title
export const getSeriesRelativeUrl = (seriesTicker: string, seriesTitle?: string): string => {
    const mappedSeriesTicker = sportSeriesRedirects[seriesTicker] ?? seriesTicker;

    // We don't know the title if we mapped the series
    const mappedTitle = sportSeriesRedirects[seriesTicker] ? '' : seriesTitle;

    return `/markets/${mappedSeriesTicker.toLowerCase()}${
        mappedTitle ? `/${getSeriesPathDescription(mappedTitle)}` : ''
    }`;
};

export const getSeriesPathDescription = (seriesTitle: string): string =>
    `${seriesTitle
        .replaceAll('-', '')
        .replace(/ +/g, '-')
        .replace(/[^a-zA-Z0-9\-]+/g, '')
        .toLowerCase()}`;

export const luigiMangioneSeriesTickers = ['KXUHC2', 'KXUHCPLEA', 'KXUHCMOTIVE', 'KXUHCEXTRA', 'KXUHCCONVICT'];
